import { DotsHorizontalIcon } from "@radix-ui/react-icons";
import { useNavigate } from "react-router-dom";

import { useAuth } from "@/lib/use-auth";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs/tabs";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu/dropdown-menu";

import { CheckinTableForEmployee } from "./_components/checkin-table/checkin-table";
import { Button } from "@/components/ui/button/button";
import { MyDocumentsAsEmployee } from "./_components/my-documents";

const EmployeeProfilePage = () => {
  const navigate = useNavigate();

  const { data, isPending, isError, error } = useAuth();

  if (isPending) {
    return <div>Loading....</div>;
  }

  if (isError) {
    return <pre>{JSON.stringify(error)}</pre>;
  }

  return (
    <div className="p-5 md:h-[calc(100%-56px)] h-[calc(100vh-56px)] relative">
      <div className="flex flex-row items-center justify-between">
        <div className="p-4 flex gap-4">
          {data?.user?.photo ? (
            <div className="relative w-20 rounded-md">
              <img
                src={data?.user?.photo}
                alt="Uploaded Image"
                className="object-cover max-w-full rounded-md"
              />
            </div>
          ) : (
            <div className="w-20 h-20 rounded-full bg-accent flex items-center justify-center text-xl">
              {data?.user?.name?.charAt(0)}
            </div>
          )}

          <div className="flex flex-col self-center">
            <h3 className="text-2xl font-semibold">{data?.user?.name}</h3>
            <p className="text-sm">{data?.user?.email}</p>
          </div>

          <div className="border-l flex items-center px-4 gap-1">
            <p>Your Performance Points of this month :</p>
            <p className="text-base font-medium">
              {data?.user?.performancePoints}
            </p>
          </div>
        </div>

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              className="flex h-8 w-8 p-0 data-[state=open]:bg-muted mr-4"
            >
              <DotsHorizontalIcon className="h-4 w-4" />
              <span className="sr-only">Open menu</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-[200px]">
            {/* <DropdownMenuItem
              onMouseDown={() => {
                navigate("/employee/profile/attendance");
              }}
            >
              Attendance
            </DropdownMenuItem> */}
            {/* <DropdownMenuItem
              onMouseDown={() => {
                navigate("/employee/profile/salary-timesheet");
              }}
            >
              Salary Timesheet
            </DropdownMenuItem> */}

            {/* <DropdownMenuItem
              onMouseDown={() => {
                navigate("/employee/profile/salary");
              }}
            >
              Request Salary
            </DropdownMenuItem> */}
            {/* <DropdownMenuItem
              onMouseDown={() => {
                navigate("/employee/profile/my-salary");
              }}
            >
              My Salary
            </DropdownMenuItem> */}
            <DropdownMenuItem
              onMouseDown={() => {
                navigate("/employee/profile/performance-logs");
              }}
            >
              My Performance Logs
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
      <div className="bg-card rounded-md p-3">
        <div className="flex flex-col">
          <div className="">
            <Tabs defaultValue="checkins" className="mr-auto w-full">
              <div className="flex items-center justify-between pb-3 sticky top-[56px] bg-card z-30">
                <TabsList className="w-full justify-start rounded-none border-b border-b-gray-500 bg-transparent p-0">
                  <TabsTrigger
                    value="checkins"
                    className="relative h-9 rounded-none border-b-2 border-b-transparent bg-transparent px-4 pb-3 pt-2 font-semibold text-muted-foreground shadow-none transition-none data-[state=active]:border-b-primary data-[state=active]:text-foreground data-[state=active]:bg-transparent data-[state=active]:shadow-none"
                  >
                    Checkins
                  </TabsTrigger>
                  <TabsTrigger
                    value="my-documents"
                    className="relative h-9 rounded-none border-b-2 border-b-transparent bg-transparent px-4 pb-3 pt-2 font-semibold text-muted-foreground shadow-none transition-none data-[state=active]:border-b-primary data-[state=active]:text-foreground data-[state=active]:bg-transparent data-[state=active]:shadow-none"
                  >
                    My Documents
                  </TabsTrigger>
                </TabsList>
              </div>

              <TabsContent value="checkins" className="relative rounded-md">
                <CheckinTableForEmployee />
              </TabsContent>
              <TabsContent value="my-documents" className="relative rounded-md">
                <MyDocumentsAsEmployee />
              </TabsContent>
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeProfilePage;
